import src from "IMAGE";
export default { src, width: 452, height: 300, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
